module.exports = __webpack_public_path__ + "static/mobilepartners-99858d3826cc64f137a4fdc6efd7d2af.png";